import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      --phineas-card-gap: calc(16rem / var(--default-rem-px-count));
      --phineas-intro-max-width: 100%;
    }

    .phineas-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
    }

    .intro {
      grid-column: 2 / 8;
      grid-row: 2;
      display: flex;
      flex-direction: column;
      gap: calc(30rem / var(--default-rem-px-count));
      max-width: var(--phineas-intro-max-width);
      margin: 0 auto;
      padding-bottom: calc(50rem / var(--default-rem-px-count));
      text-align: center;
      color: var(--block-text-color, #222);
    }

    .cards {
      grid-column: 2 / 8;
      grid-row: 3;
      display: flex;
      flex-wrap: wrap;
      gap: var(--phineas-card-gap);
    }

    .card {
      flex: 0 0 calc((100% - var(--phineas-card-gap)) / 2);
      min-width: 0;
      display: flex;
      flex-direction: column;
      gap: calc(20rem / var(--default-rem-px-count));
      color: var(--block-text-color, #222);
    }

    .card-image {
      width: 100%;
    }

    .card-image img {
      width: 100%;
      height: auto;
      display: block;
    }

    @media (min-width: 600px) {
      :host {
        --phineas-card-gap: calc(16rem / var(--default-rem-px-count));
        --phineas-intro-max-width: calc(480rem / var(--default-rem-px-count));
      }

      .phineas-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
      }

      .intro {
        grid-column: 2 / 14;
        gap: calc(40rem / var(--default-rem-px-count));
        padding-bottom: calc(60rem / var(--default-rem-px-count));
      }

      .cards {
        grid-column: 2 / 14;
        flex-wrap: nowrap;
      }

      .card {
        flex: 1 1 0;
        gap: calc(40rem / var(--default-rem-px-count));
      }
    }

    @media (min-width: 1024px) {
      :host {
        --phineas-card-gap: calc(32rem / var(--default-rem-px-count));
        --phineas-intro-max-width: calc(668rem / var(--default-rem-px-count));
      }
    }
  `,
];
